module.exports = __webpack_public_path__ + "media/images/logos/secondary-bcs-82519f0d283d903abaaf16fe8f22a3a5.svg";